import { snakeCase } from "lodash";
import { FAMILY, GAMER, LIGHT, PLAY } from "../consts/typePlans";

export default function(planFiltred) {
  const cidade = snakeCase(planFiltred[0].plans[0].cidade);
  console.log(cidade);

  let bloco =
    cidade === "bom_jesus_pi"
      ? [[30, 50, 100], [200, 300], [], [10]]
      : [[100, 200, 300], [400, 500], [750, 1000], [50]];

  planFiltred = planFiltred.map(val => {
    if (val.infraestrutura !== "Fibra Óptica") {
      val.plans = val.plans.map(p => {
        p.class = "col-12 col-lg-4";
        return p;
      });
    } else {
      let listaNova = [];

      val.plans.forEach(p => {
        if (bloco[0].length && bloco[0].find(f => f === p.velocidade)) {
          p.class = "col-12 col-lg-4";
          p.type = FAMILY;
          listaNova.push(p);
        }

        if (bloco[1].length && bloco[1].find(f => f === p.velocidade)) {
          p.class = "col-12 col-lg-6";
          p.type = PLAY;
          listaNova.push(p);
        } else if (bloco[2].length && bloco[2].find(f => f === p.velocidade)) {
          p.type = GAMER;
          p.class = "col-12 col-lg-6";
          listaNova.push(p);
        } else if (bloco[3].length && bloco[3].find(f => f === p.velocidade)) {
          p.type = LIGHT;
          p.class = "col-12 col-lg-12";
          listaNova.push(p);
        }
      });

      let auxPlans = [];

      do {
        bloco.forEach(bloco => {
          listaNova.forEach(its => {
            if (bloco.find(b => b === its.velocidade)) {
              auxPlans.push(its);
            }
          });
        });
      } while (auxPlans.length < listaNova.length);

      val.plans = auxPlans;
    }

    return val;
  });

  return planFiltred;
}
